
export default function idObjectMapper(ids = [], map = {}) {
  const arr = []

  ids.forEach((id) => {
    if (map[id]) {
      arr.push(map[id])
    }
  })

  return arr
}
